import { render } from "./OrgMembersSort.vue?vue&type=template&id=1bb685a3&ts=true"
import script from "./OrgMembersSort.vue?vue&type=script&lang=ts"
export * from "./OrgMembersSort.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__